import React from "react";
import { FaRedo } from "react-icons/fa";

function TechniquesEmptyState({ onReset }) {
  return (
    <div className="mt-6 rounded-[2rem] border border-dashed border-slate-300 bg-white p-8 text-center shadow-xl shadow-slate-200/50 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <h2 className="font-titre text-2xl font-bold text-slate-950 dark:text-white">
        Aucune technique trouvée
      </h2>

      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-7 text-slate-500 dark:text-white/50">
        Aucune technique ne correspond aux filtres sélectionnés.
      </p>

      <button
        type="button"
        onClick={onReset}
        className="mt-6 inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-2 text-sm font-bold text-white transition hover:-translate-y-0.5 dark:bg-white dark:text-slate-950"
      >
        <FaRedo />
        Réinitialiser les filtres
      </button>
    </div>
  );
}

export default TechniquesEmptyState;